import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/Auth/404.css';
import '../../Styles/AuthForms.css';
import AuthFooter from './AuthFooter';

const notFoundMessages = [
  "Page not found. Let's get you back on track!",
  "This page doesn't exist. Time to head back home!",
  "The page you're looking for isn't here. Let's find you something better!",
  "This page seems to have disappeared. Let's get you back to safety!",
  "404: Page not found, but don't worry - we've got plenty of other great stuff to explore!",
  "This page is playing hide and seek. Let's go find something more cooperative!",
  "Looks like this page got lost. Time to return to the real world!",
  "This page seems to have disappeared. Let's get you back to reality!",
  "Oops! This page isn't available. Let's find you something that's actually working!",
  "This page appears to be missing. Let's find you something more visible!",
  "Looks like this page decided to go off the grid. Time to reconnect with something that's actually here!",
  "This page seems to have pulled a disappearing act. Let's find you something more reliable!",
  "Well, this page is currently missing. Let's get you back to the action!",
  "This page appears to have taken an unexpected detour. Let's get you back on the right path!",
  "Looks like this page is playing hard to get. Let's find you something more accessible!"
];

interface NotFoundProps {
  linkTo?: string;
  message?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({ linkTo = '/', message }) => {
  // useRef ensures the message is picked only once and never changes on rerender
  const messageRef = useRef<string>(
    message || notFoundMessages[Math.floor(Math.random() * notFoundMessages.length)]
  );

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <p className="not-found-message">
          {messageRef.current}
        </p>
        <Link to={linkTo} className="go-home-button">
          Go to Home
        </Link>
      </div>
      <AuthFooter />
    </div>
  );
};

export default NotFound;